import { render } from "./DetailAddressBox.vue?vue&type=template&id=fc0c4912&scoped=true"
import script from "./DetailAddressBox.vue?vue&type=script&lang=ts"
export * from "./DetailAddressBox.vue?vue&type=script&lang=ts"

import "./DetailAddressBox.vue?vue&type=style&index=0&id=fc0c4912&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-fc0c4912"

export default script